import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/pages/Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [formStatus, setFormStatus] = useState({
    submitted: false,
    loading: false,
    success: false,
    message: ''
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.message) {
      setFormStatus({ submitted: true, loading: false, success: false, message: 'Please fill in all required fields.' });
      return;
    }

    setFormStatus({ ...formStatus, loading: true });

    const submitData = new FormData();
    submitData.append('name', formData.name);
    submitData.append('email', formData.email);
    submitData.append('subject', formData.subject);
    submitData.append('message', formData.message);

    try {
      const response = await fetch('https://formsubmit.co/ajax/60260663475a7c37d31c254269b7dc9d', {
        method: 'POST',
        body: submitData
      });

      if (response.ok) {
        setFormData({ name: '', email: '', subject: '', message: '' });
        setFormStatus({ submitted: true, loading: false, success: true, message: 'Message sent successfully!' });
        navigate('/thank-you');
      } else {
        throw new Error('Submission failed');
      }
    } catch (error) {
      setFormStatus({ submitted: true, loading: false, success: false, message: 'Something went wrong. Please try again.' });
    }
  };

  return (
    <div className="contact-page">
      <section className="contact-section section">
        <div className="container">
          <div className="contact-split">
            <div className="contact-info-side">
              <span className="section-tag">Contact</span>
              <h2 className="contact-title">Let's build something <span className="text-gradient">remarkable</span>.</h2>
              <p className="contact-p">
                I'm currently available for freelance work and full-time opportunities. 
                Whether you have a specific project in mind or just want to explore possibilities, 
                I'm here to help you navigate the digital landscape.
              </p>
              
              <div className="contact-methods">
                <div className="method-card-premium glass">
                  <div className="method-icon-wrap">
                    <i className="fas fa-envelope"></i>
                  </div>
                  <div className="method-details">
                    <span>Email Me</span>
                    <p>victorikeh0@gmail.com</p>
                  </div>
                </div>
                
                <div className="method-card-premium glass">
                  <div className="method-icon-wrap">
                    <i className="fab fa-whatsapp"></i>
                  </div>
                  <div className="method-details">
                    <span>Direct Message</span>
                    <p>+234 903 254 3740</p>
                  </div>
                </div>
              </div>

              <div className="social-connect">
                <h3 className="social-subtitle">Connect with me</h3>
                <div className="social-links-artistic">
                  <a href="https://github.com/ikehvictor" target="_blank" rel="noreferrer" className="social-link-item">
                    <i className="fab fa-github"></i>
                  </a>
                  <a href="https://linkedin.com/in/ikeh-victor-a6777112b/" target="_blank" rel="noreferrer" className="social-link-item">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                  <a href="https://x.com/viky1222" target="_blank" rel="noreferrer" className="social-link-item">
                    <i className="fab fa-twitter"></i>
                  </a>
                </div>
              </div>
            </div>

            <div className="contact-form-side">
              <div className="form-card glass">
                <form onSubmit={handleSubmit} className="premium-form">
                  <div className="form-row">
                    <div className="form-group">
                      <label>Full Name</label>
                      <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="John Doe" required />
                    </div>
                    <div className="form-group">
                      <label>Email Address</label>
                      <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="john@example.com" required />
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Subject</label>
                    <input type="text" name="subject" value={formData.subject} onChange={handleChange} placeholder="Project Inquiry" />
                  </div>
                  <div className="form-group">
                    <label>Your Message</label>
                    <textarea name="message" value={formData.message} onChange={handleChange} placeholder="Tell me about your project..." rows="5" required></textarea>
                  </div>
                  <button type="submit" className="btn btn-primary w-100" disabled={formStatus.loading}>
                    {formStatus.loading ? 'Sending...' : 'Send Message'}
                  </button>
                  {formStatus.submitted && <p className={`form-msg ${formStatus.success ? 'success' : 'error'}`}>{formStatus.message}</p>}
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;